import $ from "jquery";
import BaseFilter from "./BaseFilter";
export default class TextFilter extends BaseFilter {
    constructor($node) {
        super();
        this.$node = $node;
    }
    match($item) {
        const text = this.collectStrings($item);
        const nodeValue = this.$node.val();
        const valueStr = nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.toString();
        if (!valueStr)
            return true;
        if (text.toLowerCase().includes(valueStr.toLowerCase())) {
            return true;
        }
        return false;
    }
    collectStrings($node) {
        let result = "";
        $node.find('.filterable-text').each(function (index) {
            if ($(this).text() != '') {
                result += " " + $(this).text();
            }
        });
        return result;
    }
}
